<template>
  <div v-if="show" class="dialog-overlay" @click.self="handleCancel">
    <div class="confirmation-dialog dialog-animation">
      <p>{{ message }}</p>
      <div v-if="!processing" class="dialog-buttons">
        <button @click="handleConfirm" class="confirm-button">
          <svg class="icon">
            <use href="@/assets/iconset.svg#logout_compact" />
          </svg>
          {{ confirmText }}
        </button>
        <button @click="handleCancel" class="cancel-button">
          {{ cancelText }}
        </button>
      </div>
      <div v-else class="processing-row" aria-live="polite">
        <span class="spinner" aria-hidden="true"></span>
        <span class="processing-text">Processing…</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ConfirmationDialog",
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    message: {
      type: String,
      default: "Are you sure?",
    },
    confirmText: {
      type: String,
      default: "Yes",
    },
    cancelText: {
      type: String,
      default: "No",
    },
    processing: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["confirm", "cancel"],
  methods: {
    handleConfirm() {
      this.$emit("confirm");
    },
    handleCancel() {
      this.$emit("cancel");
    },
  },
};
</script>

<style scoped>
.dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--bg-main-dark);
  /* background-color: rgba(0, 0, 0, 0.7); */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
  backdrop-filter: blur(5px);
  width: 100vw;
  height: 100vh;
}

.confirmation-dialog {
  background-color: var(--bg-main-dark);
  padding: var(--largeSpace);
  border-radius: var(--border-radius-medium);
  text-align: center;
  max-width: 300px;
  color: var(--text-white);
  animation: fadeInSlideDown var(--fastSpeed) ease-out forwards;
  border: 1px solid var(--grey-darkest);
}

.dialog-buttons {
  display: flex;
  justify-content: center;
  gap: var(--space);
  margin-top: var(--space);
}

.processing-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--space);
  margin-top: var(--space);
}

.spinner {
  width: 16px;
  height: 16px;
  border: 2px solid var(--grey-darkest);
  border-top-color: var(--text-white);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.confirm-button,
.cancel-button {
  padding: var(--space) var(--doubleSpace);
  border: 1px solid var(--text-white);
  border-radius: var(--border-radius-pill);
  cursor: pointer;
  transition: all var(--fastSpeed) ease;
  background-color: transparent;
  color: var(--text-white);
  height: var(--clickableHeight);
}

.confirm-button:hover,
.cancel-button:hover {
  background-color: var(--grey-darkest);
}

button.confirm-button .icon {
  transform: translateX(-5px);
}
</style>
